import { render, staticRenderFns } from "./templateList.vue?vue&type=template&id=279b4dd3&scoped=true&"
import script from "./templateList.vue?vue&type=script&lang=js&"
export * from "./templateList.vue?vue&type=script&lang=js&"
import style0 from "./templateList.vue?vue&type=style&index=0&id=279b4dd3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "279b4dd3",
  null
  
)

export default component.exports